<template>
    <div v-if="profile">
      <div class="profile-block__contacts">
        <div class="col-xs-12 profile-block__input-row">
          <div class="profile-block__label">Имя*</div>
          <input type="text" class="inputbox" v-model="profile.NAME">
        </div>
        <div class="col-xs-12 profile-block__input-row">
          <div class="profile-block__label">Фамилия*</div>
          <input type="text" class="inputbox" v-model="profile.LAST_NAME">
        </div>
        <div class="col-xs-12 profile-block__input-row">
          <div class="profile-block__label">Телефон*</div>
          <input type="text" class="inputbox" v-model="profile.PERSONAL_MOBILE">
        </div>
        <div class="col-xs-12 profile-block__input-row">
          <div class="profile-block__label">Дата рождения</div>
          <datepicker input-class="inputbox" use-utc :language="ru" v-model="profile.PERSONAL_BIRTHDAY"></datepicker>
        </div>
        <div class="col-xs-12 profile-block__input-row">
          <div v-for="(error,k) in errors" :key="k" class="input-row__error">{{ error.title }}</div>
          <div v-show="success" class="input-row__success">Сохранено</div>
        </div>
        <div class="col-xs-12 profile-block__input-row">
          <a @click.prevent="saveUserProfile()" class="btn btn--black btn--block btn--next btn--md">
            <span>Сохранить</span>
          </a>
        </div>
      </div>
      <profile-footer-menu></profile-footer-menu>
    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";
    import api from "@/api/profile";
    import Datepicker from 'vuejs-datepicker';
    import {ru} from 'vuejs-datepicker/dist/locale'
    import ProfileFooterMenu from "@/components/Personal/ProfileFooterMenu";

    export default {
        name: 'ProfileEdit',
        components: {
          ProfileFooterMenu,
          Datepicker,
        },
        data() {
          return {
            ru,
            errors: [],
            success: false,
          }
        },
        computed: {
          ...mapState('StorePersonal', ['profile']),
        },
        watch: {

        },
        methods: {
          ...mapActions('StorePersonal', ['loadProfile']),
          saveUserProfile() {
            this.errors = [];
            this.success = false;

            api.saveUserProfile(this.profile, responseData => {
                  if (responseData.errors) {
                    this.errors = responseData.errors;
                  } else {
                    this.success = true;
                  }
                },
                err => this.errors = [{'title': err}]
            );
          }
        },
        mounted() {
          this.loadProfile();
        }
    }
</script>